export default __webpack_public_path__ + "static/pulzion22-79cafcb7565e3d712dc8744b5853e926.jpg";